import { withAsyncContext as _withAsyncContext, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-4 overflow-x-auto min-h-[420px]"
}
const _hoisted_2 = { class: "w-full table-auto" }
const _hoisted_3 = { class: "font-bold text-left capitalize border-b-2 border-black divide-x divide-gray-300" }
const _hoisted_4 = {
  scope: "col",
  class: "w-16 px-2 py-2"
}
const _hoisted_5 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_6 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_7 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_8 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_9 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_10 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_11 = {
  scope: "col",
  class: "w-64 px-2 py-2"
}
const _hoisted_12 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_13 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_14 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_15 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_16 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_17 = {
  scope: "col",
  class: "w-64 px-2 py-2"
}
const _hoisted_18 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_19 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_20 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_21 = { class: "flex items-center" }
const _hoisted_22 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_23 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_24 = {
  scope: "col",
  class: "px-2 py-2"
}
const _hoisted_25 = { class: "relative flex items-center justify-between w-full" }
const _hoisted_26 = { class: "flex items-center" }
const _hoisted_27 = { class: "px-2 py-3 capitalize" }
const _hoisted_28 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_29 = { class: "px-2 py-2 text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_30 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_31 = { class: "px-2 py-2 text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_32 = { class: "px-2 py-2 text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_33 = { class: "px-2 py-2 text-blue-500 underline capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_34 = { class: "px-2 py-2 capitalize" }
const _hoisted_35 = { class: "px-2 py-2 capitalize whitespace-nowrap md:whitespace-normal" }
const _hoisted_36 = { class: "px-2 py-2 capitalize" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "px-2 py-2 capitalize" }
const _hoisted_39 = { key: 0 }
const _hoisted_40 = {
  key: 0,
  class: "px-2 text-sm text-white rounded-full bg-success w-fit"
}
const _hoisted_41 = {
  key: 1,
  class: "px-2 text-sm text-black rounded-full bg-warning w-fit"
}
const _hoisted_42 = {
  key: 2,
  class: "px-2 text-sm text-black rounded-full bg-danger w-fit"
}
const _hoisted_43 = { class: "px-2" }

import { PropType, ref } from "vue";
import { useRoute } from "vue-router";

import PaginationBar from "../PaginationBar.vue";
import ToggleCheckbox from "../ToggleCheckbox.vue";
import SearchTableHeader from "./SearchTableHeader.vue";
import FilterTableHeader from "./FilterTableHeader.vue";
import SortableTableHeader from "./SortableTableHeader.vue";

import api from "@/api/api";
import { License } from "@/types";
import { useGlobalStore } from "@/store";
import { useFilters } from "@/composables/filters";


export default /*#__PURE__*/_defineComponent({
  __name: 'LicensesTable',
  props: {
  showFilters: {
    type: Boolean,
    required: false,
    default: false,
  },
  filters: {
    type: Object as PropType<any>,
    required: false,
  },
},
  async setup(__props) {

let __temp: any, __restore: any

const route = useRoute();
const globalStore = useGlobalStore();
const { setFilter, resetFilters, filters, getFiltersFromQuery, sortBy } = useFilters(route);



const paymentMethodsFilter = ["Credit/Debit Card", "Invoice"];
const statusFilters = ["abandoned", "confirmed", "pending", "refunded"];

const licenses = ref([] as License[]);
const meta = ref({} as any);
const users = ref([] as { id: string; name: string; email: string }[]);

async function markAsInvoiceIssued(org_id: number, id: number) {
  try {
    const response = await api.license.toggleLicenseInvoiceIssued(org_id, id);

    const eLicenseIndex = licenses.value.findIndex(i => i.id === id);
    licenses.value[eLicenseIndex] = response.data.license;

    const issued = response.data.license.invoice_issued ? "issued" : "not issued";

    globalStore.toast("SUCCESS", `Invoice marked as ${issued}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function markAsInvoiceAsPaid(org_id: number, id: number) {
  try {
    const response = await api.license.markLicenseInvoiceAsPaid(org_id, id);

    const eLicenseIndex = licenses.value.findIndex(i => i.id === id);
    licenses.value[eLicenseIndex] = response.data.license;
    const paid = response.data.license.invoice_paid ? "Paid" : "Unpaid";

    globalStore.toast("SUCCESS", `Invoice marked as ${paid}`);
  } catch (error) {
    globalStore.toast("ERROR", `Error updating Licence`);
  }
}

async function search() {
  const response = await api.license.listLicenses(filters.value as any);
  licenses.value = response.data.licenses;
  meta.value = response.meta;
  users.value = response.data.users;
}

getFiltersFromQuery();
;(
  ([__temp,__restore] = _withAsyncContext(() => search())),
  await __temp,
  __restore()
);

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (licenses.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_3, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t("order-no")), 1),
              _createElementVNode("th", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`placed`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "created_at",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`name`)), 1),
                  (_ctx.$props.showFilters)
                    ? (_openBlock(), _createBlock(SearchTableHeader, {
                        key: 0,
                        display_property: "name",
                        search_term: "full_name",
                        label: "user_id",
                        filter_property: "id",
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["onChange", "onReset"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`email`)), 1),
                  (_ctx.$props.showFilters)
                    ? (_openBlock(), _createBlock(SearchTableHeader, {
                        key: 0,
                        display_property: "email",
                        search_term: "email",
                        label: "user_id",
                        filter_property: "id",
                        onChange: _unref(setFilter),
                        onReset: _unref(resetFilters)
                      }, null, 8, ["onChange", "onReset"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("th", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`trained-by`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "organisations.name",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`event`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "events.name",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`level`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "level",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t("quantity")), 1),
                  _createVNode(SortableTableHeader, {
                    column: "amount",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`payment-method`)), 1),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(SortableTableHeader, {
                      column: "payment_method",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "method",
                          currentValue: _unref(filters).method,
                          filters: paymentMethodsFilter,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createElementVNode("th", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`invoice-issued`)), 1),
                  _createVNode(SortableTableHeader, {
                    column: "invoice_issued",
                    onSort: _unref(sortBy)
                  }, null, 8, ["onSort"])
                ])
              ]),
              _createElementVNode("th", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(`paid`)), 1),
                  _createElementVNode("div", _hoisted_26, [
                    _createVNode(SortableTableHeader, {
                      column: "payment_status",
                      onSort: _unref(sortBy)
                    }, null, 8, ["onSort"]),
                    (_ctx.$props.showFilters)
                      ? (_openBlock(), _createBlock(FilterTableHeader, {
                          key: 0,
                          label: "status",
                          currentValue: _unref(filters).status,
                          filters: statusFilters,
                          onChange: _unref(setFilter),
                          onReset: _unref(resetFilters)
                        }, null, 8, ["currentValue", "onChange", "onReset"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(licenses.value, (license) => {
              return (_openBlock(), _createElementBlock("tr", {
                class: "border-b border-gray-400 divide-x divide-gray-300",
                key: license.id
              }, [
                _createElementVNode("td", _hoisted_27, _toDisplayString(license.id), 1),
                _createElementVNode("td", _hoisted_28, _toDisplayString(new Date(license.created_at).toDateString()), 1),
                _createElementVNode("td", _hoisted_29, [
                  _createVNode(_component_router_link, {
                    to: { name: 'User_Profile', params: { id: license.user.id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(license.user.first_name) + " " + _toDisplayString(license.user.last_name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", _hoisted_30, _toDisplayString(license.user.email), 1),
                _createElementVNode("td", _hoisted_31, _toDisplayString(license.organisation ? license.organisation.name : null), 1),
                _createElementVNode("td", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Training_Event', params: { id: license.event_id } }
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(license.event!.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ]),
                _createElementVNode("td", _hoisted_33, _toDisplayString(license.level), 1),
                _createElementVNode("td", _hoisted_34, _toDisplayString(license.amount), 1),
                _createElementVNode("td", _hoisted_35, _toDisplayString(license.payment_method === "Invoice" ? _ctx.$t("invoice") : _ctx.$t("credit-debit-card")), 1),
                _createElementVNode("td", _hoisted_36, [
                  (license.payment_method !== 'Invoice')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37))
                    : (_openBlock(), _createBlock(ToggleCheckbox, {
                        key: 1,
                        value: license.invoice_issued,
                        onToggle: ($event: any) => (markAsInvoiceIssued(license.organisation_id, license.id))
                      }, null, 8, ["value", "onToggle"]))
                ]),
                _createElementVNode("td", _hoisted_38, [
                  (license.payment_method !== 'Invoice')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_39, [
                        (license.payment_status === 'complete')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, _toDisplayString(_ctx.$t("yes")), 1))
                          : _createCommentVNode("", true),
                        (license.payment_status === 'pending')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, _toDisplayString(_ctx.$t("pending")), 1))
                          : _createCommentVNode("", true),
                        (license.payment_status === 'cancelled')
                          ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(_ctx.$t("cancelled")), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : (_openBlock(), _createBlock(ToggleCheckbox, {
                        key: 1,
                        value: license.payment_status === 'complete',
                        onToggle: ($event: any) => (markAsInvoiceAsPaid(license.organisation_id, license.id))
                      }, null, 8, ["value", "onToggle"]))
                ]),
                _createElementVNode("td", _hoisted_43, [
                  _createVNode(_component_router_link, {
                    to: { name: 'Licence', params: { lid: license.id, oid: license.organisation_id } },
                    class: "text-blue"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t("manage-license")), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              ]))
            }), 128))
          ])
        ]),
        (_ctx.$props.showFilters && licenses.value)
          ? (_openBlock(), _createBlock(PaginationBar, {
              key: 0,
              meta: meta.value
            }, null, 8, ["meta"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})